import { render, staticRenderFns } from "./DashboardDivisionAdministration.vue?vue&type=template&id=4d4c9ef1&scoped=true&"
import script from "./DashboardDivisionAdministration.vue?vue&type=script&lang=js&"
export * from "./DashboardDivisionAdministration.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDivisionAdministration.vue?vue&type=style&index=0&id=4d4c9ef1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4c9ef1",
  null
  
)

export default component.exports